import axios from 'axios';

const state = {
    lang: 'es',
    menu:[],
    loading: 'empty',
    setPreview: false,
    asideShow: false,
};

const getters = {
    getLang: state => {
        return state.lang;
    },
    getAside: state => {
        return state.asideShow;
    },
    getMenu: state => {
        return state.menu;
    },
    getLoading: state => {
        return state.loading;
    },
    getPreview: state => {
        return state.setPreview;
    },
};

const mutations = {
    setLang: (state, payload) => {
        state.lang = payload;
    },
    setMenu: (state, payload) => {
        state.menu = payload;
    },
    setLoading: (state, payload) => {
        state.loading = payload;
    },
    setAside: (state, payload) => {
        state.asideShow = payload;
    },
    setPreview: (state, payload) => {
        state.setPreview = payload;
    },
};


const actions = {
    async setLocaleAsync ( { commit } , payload ) {
        commit('setLoading', true );
        commit('setLang', payload );
       let {data} = await axios.get(payload +'/main_menu' + (state.setPreview ? ('?set=' + state.setPreview) : ''));
        commit('setMenu', data.data)
        commit('setLoading', false );
    },
    setAsideShow ( { commit } , payload ) {
        commit('setAside', payload );
    },
    setPreviewAsync ( { commit } , payload ) {
        commit('setPreview', payload );
    },
};

export default {
    state,
    mutations,
    actions,
    getters
}